import * as React from 'react'

import { cn } from '@/utils/cn'
import { Separator } from '@/components/UI/Separator'

type ButtonGroupProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
  orientation?: 'horizontal' | 'vertical'
  separatorClassName?: string
}

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  (
    {
      children,
      className,
      orientation = 'horizontal',
      separatorClassName,
      ...props
    },
    ref,
  ) => {
    const items = React.Children.toArray(children).filter(Boolean)
    const isVertical = orientation === 'vertical'
    const separatorOrientation = isVertical ? 'horizontal' : 'vertical'

    return (
      <div
        ref={ref}
        role='group'
        data-orientation={orientation}
        className={cn(
          'flex [&_Button]:active:scale-100',
          isVertical
            ? 'flex-col [&>*:not([data-slot=separator]):not(:first-child)]:rounded-t-none [&>*:not([data-slot=separator]):not(:first-child)]:border-t-0 [&>*:not([data-slot=separator]):not(:last-child)]:rounded-b-none [&>*:not([data-slot=separator]):not(:last-child)]:border-b-0'
            : 'flex-row [&>*:not([data-slot=separator]):not(:first-child)]:rounded-l-none [&>*:not([data-slot=separator]):not(:first-child)]:border-l-0 [&>*:not([data-slot=separator]):not(:last-child)]:rounded-r-none [&>*:not([data-slot=separator]):not(:last-child)]:border-r-0',
          className,
        )}
        {...props}
      >
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {item}
            {index < items.length - 1 ? (
              <Separator
                orientation={separatorOrientation}
                className={cn('bg-stroke-2', separatorClassName)}
              />
            ) : null}
          </React.Fragment>
        ))}
      </div>
    )
  },
)

ButtonGroup.displayName = 'ButtonGroup'

export { ButtonGroup }
